import { gql, useQuery } from '@apollo/client';
import { useNotificationContext } from '@modules/common/components/Notification/NotificationContext';
import {
  GetPermissionsForUserTypesInput,
  Query,
  UserType,
} from 'generated/graphql';
import { useGetUser } from 'v2/core/services/user';

export const FETCH_PERMISSIONS_FOR_USER_TYPES = gql`
  query getPermissionsForUserTypes($tenantID: ID!, $types: [UserType!]!) {
    getPermissionsForUserTypes(
      request: { tenantID: $tenantID, types: $types }
    ) {
      typeWithPermissions {
        type
        permissions {
          resource
          operation
        }
      }
    }
  }
`;

export const useFetchPermissionsForUserTypes = () => {
  const {
    tenant: { id: tenantID },
  } = useGetUser();

  const { showErrorNotification } = useNotificationContext();

  const { data, loading } = useQuery<Query, GetPermissionsForUserTypesInput>(
    FETCH_PERMISSIONS_FOR_USER_TYPES,
    {
      variables: {
        tenantID,
        types: [UserType.Manager, UserType.Editor],
      },
      onError: () => {
        showErrorNotification({
          contentComponent: 'Failed to fetch permissions for user types.',
          props: {},
        });
      },
    },
  );

  const isLoading = !data && loading;

  return {
    data: data?.getPermissionsForUserTypes?.typeWithPermissions,
    isLoading,
  };
};
